import React, { useContext } from "react";
import Footer from "../../Components/Footer";
import Resume from "../../Components/Resume";
import { Button } from '@mui/material';
import { DefaultContext } from '../../Contexts/DefaultContext';
import { ptbr, eng } from '../../Translate';
import '../../index.css';
import './local.css';

function Experience() {
    const { LNG } = useContext(DefaultContext)
    return (
        <div id='experience-container'>
            <h1 className="titleTxt title-exp">
                {LNG ? ptbr.expirience.item_0.item_0_1 : eng.experience.item_0.item_0_1}
            </h1>
            <Resume />
            <Button
                className='act-button'
                variant='contained'
                onClick={
                    () => window.open('https://www.linkedin.com/in/guilhermedora/', '_blank')
                }
            >
                {LNG ? ptbr.expirience.item_7.item_7_1 : eng.experience.item_7.item_7_1}
            </Button>
            <Footer />
        </div>
    );
}

export default Experience;